import { ArrowUUpLeftIcon } from '@phosphor-icons/react'

import { emailVariablesSections } from '@/common/constants'

export const liquidEditorHeight = '560px'

export const liquidEditorThemeName = 'reveni-liquid'

export const liquidDocumentationUrl = 'https://shopify.github.io/liquid/'

export const liquidErrorLineNumberClassName = 'liquid-error-line-number'

export const liquidErrorsCount = 1

export const liquidEditorOptions = {
  minimap: { enabled: false },
  stickyScroll: { enabled: false },
  scrollBeyondLastLine: false,
  wordWrap: 'on',
  tabSize: 2,
  wordBasedSuggestions: 'off',
  fixedOverflowWidgets: true,
  fontSize: 12,
  lineHeight: 20,
  padding: { top: 8 },
  glyphMargin: false,
  'bracketPairColorization.enabled': false,
  overviewRulerLanes: 0,
  overviewRulerBorder: false,
  hideCursorInOverviewRuler: true,
  renderLineHighlightOnlyWhenFocus: true,
}

export const liquidFileNames = {
  es: 'spanish.html',
  en: 'english.html',
  fr: 'french.html',
  de: 'german.html',
  it: 'italian.html',
  pt: 'portuguese.html',
  nl: 'dutch.html',
  ko: 'korean.html',
}

export const liquidVariableTypes = {
  object: 'object',
  list: 'list',
  text: 'text',
  link: 'link',
}

export const completionItemKindByType = {
  [liquidVariableTypes.object]: 'Module',
  [liquidVariableTypes.list]: 'Variable',
  [liquidVariableTypes.text]: 'Field',
  [liquidVariableTypes.link]: 'Field',
}

const variantFields = [
  { name: 'title', label: 'Variante', type: liquidVariableTypes.text },
  { name: 'sku', label: 'SKU', type: liquidVariableTypes.text },
  { name: 'price', label: 'Precio de la variante', type: liquidVariableTypes.text },
  { name: 'image_url', label: 'URL de la imagen de la variante', type: liquidVariableTypes.link },
  {
    name: 'options',
    label: 'Opciones de la variante',
    type: liquidVariableTypes.list,
    itemName: 'option',
    fields: [
      { name: 'name', label: 'Nombre de la opción', type: liquidVariableTypes.text },
      { name: 'value', label: 'Valor de la opción', type: liquidVariableTypes.text },
    ],
  },
]

const productFields = [
  { name: 'name', label: 'Nombre del producto', type: liquidVariableTypes.text },
  { name: 'quantity', label: 'Cantidad', type: liquidVariableTypes.text },
  { name: 'amount', label: 'Importe', type: liquidVariableTypes.text },
  { name: 'image', label: 'URL de la imagen del producto', type: liquidVariableTypes.link },
  { name: 'variant', label: 'Variante', type: liquidVariableTypes.object, fields: variantFields },
]

const returnItemFields = [
  { name: 'name', label: 'Nombre del producto', type: liquidVariableTypes.text },
  { name: 'amount', label: 'Importe', type: liquidVariableTypes.text },
  { name: 'image', label: 'URL de la imagen del producto', type: liquidVariableTypes.link },
  { name: 'status', label: 'Estado del producto', type: liquidVariableTypes.text },
  { name: 'reason_display', label: 'Motivo de devolución', type: liquidVariableTypes.text },
  { name: 'subreason_display', label: 'Submotivo de devolución', type: liquidVariableTypes.text },
  { name: 'reject_reason_text', label: 'Motivo de rechazo', type: liquidVariableTypes.text },
  { name: 'customer_notes', label: 'Notas del cliente', type: liquidVariableTypes.text },
  { name: 'variant', label: 'Variante', type: liquidVariableTypes.object, fields: variantFields },
  { name: 'exchanged_for_item', label: 'Producto de cambio', type: liquidVariableTypes.object, fields: productFields },
]

export const liquidVariables = [
  {
    name: 'store',
    label: 'Tienda',
    type: liquidVariableTypes.object,
    section: 'store',
    fields: [
      { name: 'name', label: 'Nombre de la tienda', type: liquidVariableTypes.text },
      { name: 'url', label: 'URL de la tienda', type: liquidVariableTypes.link },
      { name: 'return_portal_url', label: 'URL del portal de devoluciones', type: liquidVariableTypes.link },
      { name: 'cd_url', label: 'URL del panel de cliente', type: liquidVariableTypes.link },
      { name: 'contact_email', label: 'Correo de contacto', type: liquidVariableTypes.text },
      { name: 'contact_url', label: 'URL de contacto', type: liquidVariableTypes.link },
      { name: 'returns_policy_url', label: 'URL política de devoluciones', type: liquidVariableTypes.link },
      { name: 'help_center_url', label: 'URL del Centro de Ayuda', type: liquidVariableTypes.link },
    ],
  },
  {
    name: 'customer',
    label: 'Cliente',
    type: liquidVariableTypes.object,
    section: 'customer',
    fields: [
      { name: 'first_name', label: 'Nombre', type: liquidVariableTypes.text },
      { name: 'last_name', label: 'Apellidos', type: liquidVariableTypes.text },
      { name: 'email', label: 'Correo electrónico', type: liquidVariableTypes.text },
    ],
  },
  {
    name: 'order',
    label: 'Pedido',
    type: liquidVariableTypes.object,
    section: 'order',
    fields: [
      { name: 'name', label: 'Número de pedido', type: liquidVariableTypes.text },
      { name: 'return_url', label: 'URL de devolución', type: liquidVariableTypes.link },
      { name: 'tracking_url', label: 'URL de seguimiento del pedido', type: liquidVariableTypes.link },
    ],
  },
  {
    name: 'transaction',
    label: 'Transacción',
    type: liquidVariableTypes.object,
    section: 'transaction',
    fields: [
      { name: 'sequence_number', label: 'Número de secuencia de devolución', type: liquidVariableTypes.text },
      { name: 'type', label: 'Tipo de transacción', type: liquidVariableTypes.text },
      { name: 'status', label: 'Estado de la transacción', type: liquidVariableTypes.text },
      { name: 'cd_url', label: 'URL del panel de cliente', type: liquidVariableTypes.link },
      { name: 'return_carrier', label: 'Transportista de la devolución', type: liquidVariableTypes.text },
      { name: 'refund_amount', label: 'Importe del reembolso', type: liquidVariableTypes.text },
      { name: 'total_refunded_amount', label: 'Importe total reembolsado', type: liquidVariableTypes.text },
      { name: 'refund_bank_account', label: 'Cuenta bancaria del reembolso', type: liquidVariableTypes.text },
      { name: 'payment_amount', label: 'Importe del pago', type: liquidVariableTypes.text },
      { name: 'payment_link', label: 'URL del enlace de pago', type: liquidVariableTypes.link },
    ],
  },
  {
    name: 'return',
    label: 'Devolución',
    type: liquidVariableTypes.object,
    section: 'return',
    fields: [
      { name: 'customers_url', label: 'URL de la devolución en el panel de cliente', type: liquidVariableTypes.link },
      { name: 'carrier_tracking_url', label: 'URL de seguimiento del transportista', type: liquidVariableTypes.link },
      { name: 'pickup_date', label: 'Fecha de recogida', type: liquidVariableTypes.text },
      {
        name: 'on_hold_decline_reason',
        label: 'Motivo de rechazo de la solicitud en espera',
        type: liquidVariableTypes.text,
      },
      {
        name: 'discount_code',
        label: 'Código de descuento',
        type: liquidVariableTypes.object,
        fields: [
          { name: 'code', label: 'Código de descuento', type: liquidVariableTypes.text },
          { name: 'value_display', label: 'Valor del código de descuento', type: liquidVariableTypes.text },
          { name: 'duration_display', label: 'Validez del código de descuento', type: liquidVariableTypes.text },
        ],
      },
      {
        name: 'summary',
        label: 'Resumen de la devolución',
        type: liquidVariableTypes.object,
        fields: [
          {
            name: 'amount',
            label: 'Importes',
            type: liquidVariableTypes.object,
            fields: [
              { name: 'subtotal', label: 'Subtotal', type: liquidVariableTypes.text },
              { name: 'summary_total_amount', label: 'Importe total', type: liquidVariableTypes.text },
            ],
          },
          {
            name: 'items',
            label: 'Productos a devolver',
            type: liquidVariableTypes.list,
            itemName: 'item',
            fields: returnItemFields,
          },
          {
            name: 'accepted_items',
            label: 'Productos aceptados',
            type: liquidVariableTypes.list,
            itemName: 'item',
            fields: returnItemFields,
          },
          {
            name: 'rejected_items',
            label: 'Productos rechazados',
            type: liquidVariableTypes.list,
            itemName: 'item',
            fields: returnItemFields,
          },
          {
            name: 'new_items',
            label: 'Productos solicitados',
            type: liquidVariableTypes.list,
            itemName: 'item',
            fields: productFields,
          },
        ],
      },
    ],
  },
  {
    name: 'extra',
    label: 'Instrucciones de devolución',
    type: liquidVariableTypes.object,
    section: 'return',
    fields: [
      {
        name: 'steps',
        label: 'Pasos de la devolución',
        type: liquidVariableTypes.list,
        itemName: 'step',
        fields: [{ name: 'message', label: 'Paso de la devolución', type: liquidVariableTypes.text }],
      },
    ],
  },
  {
    name: 'shipment',
    label: 'Envío',
    type: liquidVariableTypes.object,
    section: 'shipment',
    fields: [
      { name: 'status', label: 'Estado del envío', type: liquidVariableTypes.text },
      { name: 'carrier', label: 'Transportista del envío', type: liquidVariableTypes.text },
      { name: 'tracking_url', label: 'URL página de seguimiento', type: liquidVariableTypes.link },
      { name: 'destination_address', label: 'Dirección de destino', type: liquidVariableTypes.text },
      { name: 'reference_number', label: 'Número de referencia del envío', type: liquidVariableTypes.text },
      {
        name: 'shipped_items',
        label: 'Productos enviados',
        type: liquidVariableTypes.list,
        itemName: 'item',
        fields: productFields,
      },
    ],
  },
]

export const liquidVariableSections = [
  ...emailVariablesSections,
  { label: 'Devolución', Icon: ArrowUUpLeftIcon, id: 'return' },
]
